// extracted by mini-css-extract-plugin
module.exports = {"add-new":"_3Wzpc","addNew":"_3Wzpc"};